module.exports = __webpack_public_path__ + "assets/img/001.2f2804c0.jpg";